import { NgModule } from '@angular/core';

import { LayoutConfig } from '@spartacus/storefront';
import { provideConfig } from '@spartacus/core';
import { KbsSitePaginationModule } from './common/components/kbs-site-pagination/kbs-site-pagination.module';
import { KbsSiteDocSearchPageModule } from './kbs-site-doc-search-page/kbs-site-doc-search-page.module';

const layoutConfig: LayoutConfig = {
  layoutSlots: {
    header: {
      slots: ['SiteLogo'],
    },
    KbsSiteHomePageTemplate: {
      slots: ['SiteBanner', 'BodyContent'],
    },
    KBSDocumentLibrarySearchPageTemplate: {
      slots: ['BodyContent'],
    },
    footer: {
      slots: [],
    },
  },
};

@NgModule({
  imports: [KbsSiteDocSearchPageModule, KbsSitePaginationModule],
  exports: [KbsSiteDocSearchPageModule, KbsSitePaginationModule],
  providers: [provideConfig(layoutConfig)],
})
export class CustomFeatureModule { }
